import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '../components/HelloWorld'
import Login from '../components/Login'
import loginService from '../services/login'
import UsuariosLista from '../components/usuarios/UsuariosLista'
import UsuarioDetalle from '../components/usuarios/UsuarioDetalle'
import GruposLista from '../components/grupos/GruposLista'
import GrupoDetalle from '../components/grupos/GrupoDetalle'
import CarriersLista from '../components/carriers/CarriersLista'
import CarrierDetalle from '../components/carriers/CarrierDetalle'
import ClientesLista from '../components/clientes/ClientesLista'
import ClienteDetalle from '../components/clientes/ClienteDetalle'
import ComandosLista from '../components/comandos/ComandosLista'
import ComandoDetalle from '../components/comandos/ComandoDetalle'
import ServidoresLista from '../components/servidores/ServidoresLista'
import ServidorDetalle from '../components/servidores/ServidorDetalle'
import TracksLista from '../components/tracks/TracksLista'
import TrackDetalle from '../components/tracks/TrackDetalle'
import VehiculosLista from '../components/vehiculos/VehiculosLista'
import VehiculoDetalle from '../components/vehiculos/VehiculoDetalle'
import PerfilComponent from '../components/perfil/PerfilComponent'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HelloWorld
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: PerfilComponent
    },
    {
      path: '/usuarios',
      name: 'Usuarios',
      component: UsuariosLista
    },
    {
      path: '/usuarios/:id',
      name: 'UsuarioDetalle',
      component: UsuarioDetalle
    },
    {
      path: '/grupos',
      name: 'Grupos',
      component: GruposLista
    },
    {
      path: '/grupos/:id',
      name: 'GrupoDetalle',
      component: GrupoDetalle
    },
    {
      path: '/carriers',
      name: 'Carriers',
      component: CarriersLista
    },
    {
      path: '/carriers/:id',
      name: 'CarrierDetalle',
      component: CarrierDetalle
    },
    {
      path: '/clientes',
      name: 'Clientes',
      component: ClientesLista
    },
    {
      path: '/clientes/:id',
      name: 'ClienteDetalle',
      component: ClienteDetalle
    },
    {
      path: '/comandos',
      name: 'Comandos',
      component: ComandosLista
    },
    {
      path: '/comandos/:id',
      name: 'ComandoDetalle',
      component: ComandoDetalle
    },
    {
      path: '/servidores',
      name: 'Servidores',
      component: ServidoresLista
    },
    {
      path: '/servidores/:id',
      name: 'ServidorDetalle',
      component: ServidorDetalle
    },
    {
      path: '/tracks',
      name: 'Tracks',
      component: TracksLista
    },
    {
      path: '/tracks/:id',
      name: 'TrackDetalle',
      component: TrackDetalle
    },
    {
      path: '/vehiculos',
      name: 'Vehiculos',
      component: VehiculosLista
    },
    {
      path: '/vehiculos/:id',
      name: 'VehiculoDetalle',
      component: VehiculoDetalle
    },
  ]
})

router.beforeEach(async function(to, from, next) {
  if (to.name === 'Login') {
    next()
  }
  let logged = await loginService.checarSesion()
  if (!logged.ok){
    router.replace({ path: '/login' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js